export default "<canvas id=\"sellerPageCategoriesChart\"></canvas>\r\n"